import { MarkovStartvector } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setMarkovStartvectors = (startvectors: MarkovStartvector[]) => ({
    type: inferLiteral(types.MARKOV_STARTVECTORS),
    startvectors,
})
export const setMarkovStartvectorSelected = (startvector: MarkovStartvector) => ({
    type: inferLiteral(types.MARKOV_STARTVECTOR_SELECTED),
    startvector,
})
export const setMarkovStartvectorEdit = (startvector: MarkovStartvector) => ({
    type: inferLiteral(types.MARKOV_STARTVECTOR_EDIT),
    startvector,
})
export const setMarkovStartvectorReloadList = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_STARTVECTOR_RELOAD_LIST),
    value,
})
export const setMarkovStartvectorReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_STARTVECTOR_RELOAD_EDIT),
    value,
})
